module.exports = "/assets/data/a378da1f4a1586cbfa9df93a9f735df4-WS3.data.json";